<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formCostCenter">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar obra'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteCostCenter()"></app-custom-button>

            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              [width]="'5.5rem'" [icon]="'pi pi-plus'" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="costCenterContract.userNameCreate"
              [createDate]="costCenterContract.createDate" [userNameUpdate]="costCenterContract.userNameUpdate"
              [updateDate]="costCenterContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
              <app-custom-input-text [labelText]="'Empresa'" [value]="codeNameEnterprise" [required]="true"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-12">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode()"></app-custom-input-number>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-6 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true"
                [maxLength]="70"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-12">
              <app-custom-select formControlName="costCenterTypeId" [labelText]="'Tipo'" [list]="listCostCenterTypes"
                [required]="true"></app-custom-select>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3 col-12">
              <app-custom-input-number formControlName="ratePromptPayment" [labelText]="'% Pronto Pago'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="constructionSiteId" [labelText]="'Obra'" [required]="true"
                [list]="listConstructionSites"
                (onChangeSelect)="getEnterpriseAndClientByConstructionSiteIdAsync($event, true)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <app-custom-input-text [labelText]="'Cliente'" [required]="true" [disabled]="true"
                [value]="codeNameClient"></app-custom-input-text>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 col-11">
              <app-custom-autocomplete formControlName="invoicingModelId" [labelText]="'Modelo de Factura'"
                [required]="true" [list]="listInvoicingModels">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-1 d-flex align-items-end">
              <app-custom-button [title]="'Ver modelo fra. detallado'" [icon]="'pi pi-external-link'"
                [severity]="'success'" (onClick)="openInvoicingModel()"></app-custom-button>
            </div>
            <div [hidden]="!swDispersedArticle" class="col-lg-5 col-md-5 col-sm-5 col-11">
              <app-custom-autocomplete formControlName="accountingModelId" [labelText]="'Modelo Contable'"
                [list]="listAccountingModels"></app-custom-autocomplete>
            </div>
            @if (swDispersedArticle) {
            <div class="col-lg-1 col-md-1 col-sm-1 col-1 d-flex align-items-end">
              <app-custom-button [title]="'Ver modelo contab. detallado'" [icon]="'pi pi-external-link'"
                [severity]="'success'" (onClick)="openAccountingModel()"></app-custom-button>
            </div>
            }
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="priceListId" [labelText]="'Lista Precios'" [required]="true"
                [list]="listPriceLists">
              </app-custom-autocomplete>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-12">
          <div class="row">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-select formControlName="ivaTypeId" [labelText]="'Tipo IVA'" [list]="listIvaTypes"
                  [required]="true" (onChangeSelect)="getIvaType($event)"></app-custom-select>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-input-number formControlName="administrationRate" [labelText]="'% Admón.'"
                  [required]="!disabledFormInvoicing"></app-custom-input-number>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-input-number formControlName="incidentalRate" [labelText]="'% Imprev.'"
                  [required]="!disabledFormInvoicing"></app-custom-input-number>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-input-number formControlName="utilityRate" [labelText]="'% Util.'"
                  [required]="!disabledFormInvoicing"></app-custom-input-number>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo AIU'" [list]="listArticles"
                  [required]="!disabledFormInvoicing" [recovery]="true" [showExtraButton]="true"
                  [titleExtraButton]="'Seleccionar Artículo'" [iconExtraButton]="'pi pi-external-link'"
                  (clickExtraButton)="openArticleAIUModal()"></app-custom-autocomplete>
                <app-custom-modal #selectArticleForCostCenter [label]="'Nuevo'" [header]="'Selección de Articulos'"
                  [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
                  (selectedItems)="setArticleAIU($event)" hidden></app-custom-modal>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto AIU'"
                  [list]="listConceptInvoicings" [required]="!disabledFormInvoicing"></app-custom-select>
              </div>
            </div>
            <div class="row">
              <div class="checkbox-swInvoiceM2">
                <app-custom-checkbox formControlName="swInvoiceM2" [labelText]="'Fra. m2'"
                  (onChangeCheckBox)="onChange($event, 'swInvoiceM2')">
                </app-custom-checkbox>
              </div>
              <div class="col-lg-3 col-md-2 col-sm-3 col-12">
                <app-custom-input-decimal formControlName="unitValueM2" [labelText]="'Vr.Unitario m2'">
                </app-custom-input-decimal>
              </div>
              <div class="checkbox-swFixedQuota">
                <app-custom-checkbox formControlName="swFixedQuota" [labelText]="'Cuota Fija'"
                  (onChangeCheckBox)="onChange($event, 'swFixedQuota' )">
                </app-custom-checkbox>
              </div>
              <div class="col-lg-3 col-md-2 col-sm-3 col-12">
                <app-custom-input-decimal formControlName="valueFixedQuota" [labelText]="'Vr.Cuota Fija'">
                </app-custom-input-decimal>
              </div>
              <div class="checkbox-advance-invoice" [hidden]="!swAdvanceInvoice">
                <app-custom-checkbox formControlName="swAdvanceInvoice" [labelText]="'Factura Anticipada'"
                  (onChangeCheckBox)="onChange($event, 'swAdvanceInvoice')">
                </app-custom-checkbox>
              </div>
              <div class="col field-advance-invoice" [hidden]="!swAdvanceInvoice">
                <app-custom-select formControlName="advanceInvoiceOption" [labelText]="'Opciones Factura Anticipada'"
                  [list]="listOptionAdvanceInvoice"></app-custom-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="row d-flex align-items-end">
            <div class="col-lg-11 col-md-10 col-sm-10 col-12">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                [rows]="1" [maxLength]="250"></app-custom-textarea>
            </div>
            <div class="col-lg-1 col-md-1 col-1 mt-1">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledButtonSave"
                [variant]="undefined" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>